import { DateTime } from 'luxon'
import { parseSelectedRequestDate } from './parseSelectedRequestDate'

// Returns a valid selected date, or today's date in the store zone when only a time was chosen.
export function resolveSelectedRequestDateForApi(
  rawEventDate: Date | string | null | undefined,
  rawEventTime: string | null | undefined,
  timezone: string
): string {
  const parsed = parseSelectedRequestDate(rawEventDate, timezone)
  if (parsed?.isValid === true) return parsed.toFormat('yyyy-MM-dd')

  if (rawEventTime != null && rawEventTime !== '') {
    return DateTime.now().setZone(timezone).toFormat('yyyy-MM-dd')
  }

  return ''
}
